import { ITagOption } from '@cian/ui-kit';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IDirection } from 'shared/types/geo';
import { ITags } from 'shared/types/tags';
import { IGeoTags } from 'shared/types/tags/geoTags';

const initialState: ITags = {
  items: [],
  meta: {
    geoTags: {} as IGeoTags,
    directions: [],
    undergroundsUnderConstruction: {},
    village: null,
  },
};

export const tagsSlice = createSlice({
  name: 'tags',
  initialState,
  reducers: {
    removeAllTags: state => {
      state.items = [];
    },
    setTags: (state, action: PayloadAction<ITagOption[]>) => {
      state.items = action.payload;
    },
    setGeoTags: (state, action: PayloadAction<IGeoTags>) => {
      state.meta.geoTags = action.payload;
    },
    setDirections: (state, action: PayloadAction<IDirection[]>) => {
      state.meta.directions = action.payload;
    },
  },
});

export const {
  name: tagsReducerName,
  reducer: tagsReducer,
  actions: { removeAllTags, setTags, setGeoTags, setDirections },
} = tagsSlice;
